<script lang="ts">
import type { InjectionKey } from "vue";

export const FORM_ITEM_INJECTION_KEY
  = Symbol("form-item") as InjectionKey<string>;
</script>

<script lang="ts" setup>
import { useId } from "reka-ui";
import { provide } from "vue";

const id = useId();
provide(FORM_ITEM_INJECTION_KEY, id);
</script>

<template>
  <div
    class="
    *:data-[slot=label]:font-medium
    [&>[data-slot=control]+[data-slot=description]]:mt-2
    [&>[data-slot=control]+[data-slot=error]]:mt-2
    [&>[data-slot=description]+[data-slot=control]]:mt-2
    [&>[data-slot=label]+[data-slot=control]]:mt-2
    [&>[data-slot=label]+[data-slot=description]]:mt-1"
  >
    <slot />
  </div>
</template>
